import { render, staticRenderFns } from "./ApuracaoContratoTabAnual.vue?vue&type=template&id=7006793b"
import script from "./ApuracaoContratoTabAnual.vue?vue&type=script&lang=js"
export * from "./ApuracaoContratoTabAnual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports